import React, { useState, useRef, useEffect } from "react";
import { IconButton, Grid } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BusinessInfo from "./businessInfo";
import { BusinessData } from "../../../types";

type Props = {
  businesses: BusinessData[];
  onSelect: (business: BusinessData) => void;
};

const BusinessList: React.FC<Props> = React.memo(({ businesses, onSelect }) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 4; // Number of businesses to show at a time
  const listRef = useRef<HTMLDivElement | null>(null);
  const handleNext = () => {
    setStartIndex((prevIndex) => (prevIndex + 1) % businesses.length);
  };

  const handlePrevious = () => {
    setStartIndex(
      (prevIndex) => (prevIndex - 1 + businesses.length) % businesses.length
    );
  };

  // Smooth scrolling effect when startIndex changes
  useEffect(() => {
    if (listRef.current) {
      listRef.current.style.transition = "transform 0.5s ease-in-out";
      listRef.current.style.transform = `translateX(-${
        (100 / visibleCount) * startIndex
      }%)`;
    }
  }, [startIndex, visibleCount]);

  return (
    <div
      style={{ position: "relative", padding: "2rem 0", overflow: "hidden" }}
    >
      <IconButton
        onClick={handlePrevious}
        style={{
          position: "absolute",
          left: "1rem",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "white",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          padding: "10px",
          zIndex: 1,
        }}
      >
        <ChevronLeftIcon />
      </IconButton>

      <div
        ref={listRef}
        style={{
          display: "flex",
          width: `calc(100% + ${100 / visibleCount}%)`, // Increase width to show a bit of the next card
          padding: "0 4rem",
          transition: "transform 0.5s ease-in-out",
          transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
        }}
      >
        {businesses.map((business, index) => (
          <div
            key={`${business.businessBasic.id}-${index}`}
            style={{
              flexBasis: `${100 / visibleCount}%`,
              flexShrink: 0,
              boxSizing: "border-box",
              padding: "0 8px", // Add some horizontal padding between cards
            }}
          >
            <BusinessInfo
              business={business}
              onSelect={() => onSelect(business)}
            />
          </div>
        ))}
      </div>

      <IconButton
        onClick={handleNext}
        style={{
          position: "absolute",
          right: "1rem",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "white",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          padding: "10px",
          zIndex: 1,
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </div>
  );
});

export default BusinessList;
